export function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value))
}

/**
 * Turn an amount typed in major units (pounds, `"12.50"`) into minor
 * units (pence, `1250`). An empty string is `0`. Text that is not a
 * number gives `NaN`, so check the result with `Number.isFinite`.
 */
export function amountInMinor(amount: string): number {
  return Math.round(parseFloat(amount || '0') * 100)
}
